import React from 'react'; 
import { translate, formatData } from '../../../utils/util';

const ErrorShedMonitorItem = ({item}) => { 

    return (
        <div
            className="row"
            style={{ display: 'block', marginBottom: '0px', marginLeft: '0px', padding: '10px' }} 
        >
            <label className="title sixth-text-color" style={{ display: 'block' }}>{item.receipt?.partNumberCode}</label>
            <label className="col s6 m3 sixth-text-color" style={{ display: 'block' }}>{translate('physical-confirmation:shed')}: {item.receipt?.shed || ''} </label>  
            <label className="col s6 m3 second-text-color" style={{ display: 'block' }}>{translate('line-picking:linepicking.attempts')}: {item.attempts || ''} </label>
            <label className="col s12 sixth-text-color" style={{ display: 'block' }}>{formatData(item?.createdOn || '')} - {item.createdByDesc}</label>  
            <label className="col s12 sixth-text-color" style={{ display: 'block' }}><i className="mdi mdi-close black-text" /> {item.message}</label> 
        </div>
    );
} 

export default ErrorShedMonitorItem;
